import { render, staticRenderFns } from "./VehicleTable.vue?vue&type=template&id=28598702&scoped=true&"
import script from "./VehicleTable.vue?vue&type=script&lang=js&"
export * from "./VehicleTable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTable.vue?vue&type=style&index=0&id=28598702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28598702",
  null
  
)

export default component.exports